function localeToGoogleLang(locale: string) {
  const lang = locale?.split?.("_")?.[0];
  if (lang == "he") return "iw";
  return lang;
}

export default localeToGoogleLang;
